import { render, staticRenderFns } from "./storeGoods.vue?vue&type=template&id=7b92ddf8&"
import script from "./storeGoods.vue?vue&type=script&lang=js&"
export * from "./storeGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports